import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HelloWorldComponent} from './hello-world.component';
export class HelloWorldModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [HelloWorldComponent],
  exports: [HelloWorldComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function HelloWorldModule_tsickle_Closure_declarations() {
/** @type {?} */
HelloWorldModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HelloWorldModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
